import React from 'react';
import { Send, TicketPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const CoryInputBar = React.forwardRef(function CoryInputBar(
  { input, setInput, loading, onSubmit, onToggleTicket },
  inputRef,
) {
  return (
    <form
      onSubmit={onSubmit}
      className="px-4 py-3 border-t border-slate-200/60 flex items-center gap-2 shrink-0 bg-white/40"
    >
      <button
        type="button"
        data-testid="cory-toggle-ticket"
        onClick={onToggleTicket}
        className="p-2 rounded-xl text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors"
        title="Create support ticket"
      >
        <TicketPlus className="w-4 h-4" />
      </button>
      <input
        ref={inputRef}
        data-testid="cory-chat-input"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Ask Cory anything..."
        className="flex-1 text-sm px-3.5 py-2.5 rounded-2xl border border-slate-200 bg-white/80 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300 transition-all"
        disabled={loading}
      />
      <Button
        type="submit"
        data-testid="cory-send-btn"
        size="sm"
        disabled={loading || !input.trim()}
        className="h-10 w-10 p-0 rounded-2xl bg-[#007AFF] hover:bg-[#0055CC] text-white shadow-md transition-all hover:shadow-lg active:scale-95"
      >
        <Send className="w-4 h-4" />
      </Button>
    </form>
  );
});
